import { addDays, eachDayOfInterval, parseISO, subDays } from 'date-fns'
import { DailyAllocationType, DailyAvailability } from '../../../../../graphql'
import { millisecondsInADay } from '../../../../constant'
import { toLocalDate } from '../../../../utility'
import { DayAllocation } from './day-allocation'
import { DayAmount } from './day-amount'

/**
 * @deprecated Should no longer be used
 */
export function extractActiveMonths(dayAmounts: DayAmount[]): Date[] {
    const months: Date[] = []

    dayAmounts
        .map(dayAmount => parseISO(dayAmount.day))
        .forEach(date => {
            if (!months.length || date.getMonth() !== months[months.length - 1].getMonth()) {
                months.push(date)
            }
        })

    return months
}

/**
 * @deprecated Should no longer be used
 */
export function extractBlockedDays(dayAllocations: DayAllocation[]): string[] {
    return dayAllocations
        .filter(dayAllocation => !dayAllocation.allocated)
        .map(dayAllocation => toLocalDate(dayAllocation.date))
}

/**
 * @deprecated Should no longer be used
 */
export function extractAvailableDays(dayAllocations: DayAllocation[]): string[] {
    return dayAllocations
        .filter(dayAllocation => dayAllocation.allocated)
        .map(dayAllocation => toLocalDate(dayAllocation.date))
}

/**
 * @deprecated Should no longer be used
 */
export function extractDailyAvailabilities(dayAllocations: DayAllocation[]): DailyAvailability[] {
    return dayAllocations.map(dayAllocation => {
        return {
            allocated: dayAllocation.allocated,
            day: toLocalDate(dayAllocation.date)
        }
    })
}

/**
 * @deprecated Should no longer be used
 */
export function extractDayAllocations(dailyAllocations: DailyAllocationType[]): DayAllocation[] {
    return dailyAllocations.map(dailyAvailability => ({
        allocated: dailyAvailability.allocated,
        date: parseISO(dailyAvailability.day)
    }))
}

/**
 * @deprecated Should no longer be used
 */
export function extractUnavailableDays(dailyAvailabilities: DailyAllocationType[]): Date[] {
    return dailyAvailabilities
        .filter(dailyAvailability => dailyAvailability.consumed >= dailyAvailability.allocated)
        .map(activeDay => parseISO(activeDay.day))
}

/**
 * @deprecated Should no longer be used
 */
export function nextDay(current: Date): Date {
    return addDays(current, 1)
}

/**
 * @deprecated Should no longer be used
 */
export function previousDay(current: Date): Date {
    return subDays(current, 1)
}

/**
 * @deprecated Should no longer be used
 */
export class SelectedRange {
    days: Date[]
}

/**
 * @deprecated Should no longer be used
 */
export function selectedRanges(dayAllocations: DayAllocation[]): SelectedRange[] {
    if (!dayAllocations) {
        throw new Error('Tried to calculate selected ranges with day allocations')
    }

    const unavailableFrom = dayAllocations
        .filter(dayAllocation => !dayAllocation.allocated)
        .map(dayAllocation => dayAllocation.date)

    const selectedRanges: SelectedRange[] = []
    let daysForNextRange: Date[] = []

    unavailableFrom.forEach((day, index) => {
        if (!daysForNextRange.length) {
            daysForNextRange = [day]
            return
        }

        const gapFromLastDay = Math.round(day.getTime() / millisecondsInADay) -
            Math.round(daysForNextRange[daysForNextRange.length - 1].getTime() / millisecondsInADay)

        if (gapFromLastDay === 1) {
            daysForNextRange = daysForNextRange.concat([day])
        } else {
            selectedRanges.push({ days: daysForNextRange })
            daysForNextRange = [day]
        }

        if (index === unavailableFrom.length - 1) {
            selectedRanges.push({ days: daysForNextRange })
        }
    })

    return selectedRanges
}

export function dateInArray(date, array) {
    return array.some(d => +d === +date);
}

/**
 * @deprecated Should no longer be used
 */
export function toDays(start: Date, end: Date): Date[] {
    return eachDayOfInterval({ start, end})
}

export function toKey(day: Date): string {
    return toLocalDate(day)
}
